import React from 'react'
import { INLINES } from '@contentful/rich-text-types'
import { Link } from 'react-scroll'

import timelineUrl from '../images/tidslinje.jpg'
import HeroImg from '../components/images/startpage-hero-processen'

import Layout from '../components/layout'
// import QuoteCarousel from '../components/quote-carousel'
// import Novus from '../components/novus'

import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import contentfulClient from '../util/contentful-client'
import { richTextDocumentToJSX } from '../util/rich-text-to-jsx'
import {
  chunkOnEmptyParagraph,
  customNodeRenderers,
  customMarkRenderers,
} from '../util/rich-text-helpers'

const richTextOptions = {
  renderNode: {
    ...customNodeRenderers,
    [INLINES.HYPERLINK]: (node, next, key) => (
      <a key={key} href={node.data.uri}>
        {next(node.content)}
      </a>
    ),
  },
  renderMark: {
    ...customMarkRenderers,
  },
}

export default class ProcessPage extends React.Component {
  state = {
    headline: '',
    preamble: [],
    page_content: [],
    page_content_middle: [],
    page_content_bottom: [],
  }

  componentDidMount() {
    contentfulClient
      .getEntries({
        content_type: 'process',
        limit: 1,
      })
      .then((entries) => {
        const entry = entries.items[0]

        if (!entry) return

        const {
          headline,
          preamble,
          page_content,
          page_content_middle,
          page_content_bottom,
        } = entry.fields

        const main_content = chunkOnEmptyParagraph(page_content).map(
          (chunk, i) => (
            <div
              className="row-darkbg mt-2"
              key={'block-' + i}
              id={'section-' + i}
            >
              <div className="row row-small">
                {documentToReactComponents(chunk)}
              </div>
            </div>
          )
        )

        const low_content = chunkOnEmptyParagraph(page_content_middle).map(
          (chunk, i) => (
            <div key={'block-' + i} id={'section-2' + i}>
              <div className="row row-medium mt-2">
                {richTextDocumentToJSX(chunk, richTextOptions)}
              </div>
            </div>
          )
        )

        const bottom_content = chunkOnEmptyParagraph(page_content_bottom).map(
          (chunk, i) => (
            <div key={'block-' + i} id={'section-3' + i}>
              <div className="row row-medium mt-2">
                {richTextDocumentToJSX(chunk, richTextOptions)}
              </div>
            </div>
          )
        )

        const preamble_content = chunkOnEmptyParagraph(
          preamble
        ).map((chunk, i) => (
          <div>{richTextDocumentToJSX(chunk, richTextOptions)}</div>
        ))

        const internal_links_main_content = chunkOnEmptyParagraph(
          page_content
        ).map((chunk, i) => (
          <Link
            key={'link-' + i}
            className="link-internal"
            activeClass="active"
            to={'section-' + i}
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
          >
            Teamen
          </Link>
        ))

        const internal_links_page_content_middle = chunkOnEmptyParagraph(
          page_content_middle
        ).map((chunk, i) => (
          <Link
            key={'link-' + i}
            className="link-internal"
            activeClass="active"
            to={'section-2' + i}
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
          >
            Utmaningar
          </Link>
        ))
        const internal_links_page_content_bottom = chunkOnEmptyParagraph(
          page_content_bottom
        ).map((chunk, i) => (
          <Link
            key={'link-' + i}
            className="link-internal"
            activeClass="active"
            to={'section-3' + i}
            spy={true}
            smooth={true}
            offset={-120}
            duration={500}
          >
            Plansamråd
          </Link>
        ))

        this.setState({
          headline,
          preamble_content,
          main_content,
          low_content,
          bottom_content,
          internal_links_main_content,
          internal_links_page_content_middle,
          internal_links_page_content_bottom,
        })
      })
  }

  render() {
    return (
      <Layout {...this.props}>
        <div className="hero-container">
          <HeroImg
            className="w-100"
            alt="Processen - Centralstationsområdet Jernhusen"
          />
        </div>

        <div className="link-group">
          <div className="row">
            {this.state.internal_links_main_content}
            {this.state.internal_links_page_content_bottom}
            {this.state.internal_links_page_content_middle}
            {/* <Link
              className="link-internal"
              activeClass="active"
              to="topplista"
              spy={true}
              smooth={true}
              offset={-120}
              duration={500}
            >
              Teamen
            </Link>
            <Link
              className="link-internal"
              activeClass="active"
              to="citat"
              spy={true}
              smooth={true}
              offset={-120}
              duration={500}
            >
              Plansamrådet
            </Link>
            <Link
              className="link-internal"
              activeClass="active"
              to="novus"
              spy={true}
              smooth={true}
              offset={-120}
              duration={500}
            >
              Utmaningar
            </Link> */}
          </div>
        </div>

        <div className="row row-medium mt-2">
          <h1>{this.state.headline}</h1>
          {this.state.preamble_content}
        </div>
        <div className="row row-medium mt-2">
          <img
            className="timelineImg"
            src={timelineUrl}
            alt="Tidslinje - Centralområdet"
          />
        </div>

        {this.state.main_content}
        {this.state.bottom_content}
        {this.state.low_content}

        {/* <section id='citat'>
        <div className="row row-mini">
          <h3 className="sub-heading mb-2">{this.state.quote_headline}</h3>
          <QuoteCarousel quotes={this.state.quotes}/>
        </div>
      </section>

      <section id='novus'>
        <div className="row row-small mb-2">
          <h2>{this.state.novus_headline}</h2>
          <p>{this.state.novus_source}</p>
        </div>
        
        <div className="row row-medium text-left mb-2">
          <Novus tabs={this.state.poll} />
        </div>

        <div className="row row-small">
          <p>
            Resultatet från webbenkäten ovan finns i sin helhet på <a className="link-underline" href="https://www.jernhusen.se/vara-projekt/Stockholm/centralstationsomradet/" rel="noopener noreferrer" target="_blank"> www.centralstationsområdet.se</a>. Klicka på platsmarkeringarna för att läsa åsikterna, statistik finns under fliken Statistik.
          </p>
        </div>
      </section>
      
      <section>
        <div className="row row-small">
          <h2>{this.state.more_headline}</h2>
          {this.state.more_content}
        </div>
      </section> */}
      </Layout>
    )
  }
}
